import React from 'react';
import { makeStyles } from '@material-ui/styles';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles(theme => ({
  title: {
    margin: '0 0 0.7em 0',
    paddingRight: '0.75em',
    width: '100%',
    fontSize: '1.75em',
    border: 'none',
    fontWeight: 600,
    background: 'none',
    color: '#595959',
  },
  inputWrap: {
    display: 'flex',
    '& button': {
      transform: 'translate(30px, -10px)',
    },
  },
  closeButton: {
    position: 'absolute',
    top: 14,
    right: 32,
  },
}));

function TitleBar(props) {
  const classes = useStyles();
  const { title, titleChange, handleClose } = props;

  return (
    <div className={classes.inputWrap}>
      <input
        placeholder="Tytuł notatki"
        className={classes.title}
        value={title}
        onChange={titleChange} 
      />
      <IconButton aria-label="Delete" className={classes.closeButton} onClick={handleClose}>
        <CloseIcon />
      </IconButton>
    </div>
  );
}

export default TitleBar;